module.exports = __webpack_public_path__ + "static/media/canva.740aebbd.svg";